import InOnePlace from './in-one-place.view';

export default InOnePlace;
